export default "__VITE_ASSET__BJgiHK0Q__"